// Module
var code = `<div class="inline-panel">
  <div class="inline-panel-wrapper">
    <button class="inline-panel-hide btn btn-default close"
            type="button"
            ng-click="\$ctrl.hideAction(\$event)">
      <span>×</span>
    </button>
    <div ng-transclude
         ng-class="{'inline-panel-wrapper--flex-row': \$ctrl.flexRow}"></div>
  </div>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/common/inline-panel/inline-panel.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;